import { CSvgAgents, CSvgSearch } from "icon"
import { useState } from "react"

export const ConvertionChatList = () => {
    const [activeChat, setActiveChat] = useState<number>(0)



    return (
        <div className="w-full md:h-full h-fit bg-hoory-100 rounded-lg flex flex-col md:p-[20px] p-[10px]">
        <div className="w-full h-[40px] border border-hoory-75 rounded-md flex items-center px-2">
          <CSvgSearch className="w-[25px] stroke-gray-400" />
          <input placeholder="Search Convertion" className="w-[calc(100%-25px)] h-full text-sm border-none px-1 focus:outline-none bg-transparent" />
        </div>
        <div className="w-full  my-2 flex items-center  overflow-hidden">
          <button onClick={() => { setActiveChat(0) }} className={`w-full h-[40px] rounded-[10px] flex items-center justify-center text-sm ${activeChat == 0 && 'bg-hoory-175 text-hoory-200'}`}>
            <span>Mine</span>
            <span className="text-xs ml-1  font-bold flex items-center justify-center rounded-full bg-white w-[15px] h-[15px]">5</span>
          </button>
          <button onClick={() => { setActiveChat(1) }} className={`w-full h-[40px] rounded-[10px] flex items-center justify-center text-sm ${activeChat == 1 && 'bg-hoory-175 text-hoory-200'}`}>
            <span>Unassigned</span>
            <span className="text-xs ml-1  font-bold flex items-center justify-center rounded-full bg-white w-[15px] h-[15px]">5</span>
          </button>
          <button onClick={() => { setActiveChat(2) }} className={`w-full h-[40px] rounded-[10px] flex items-center justify-center text-sm ${activeChat == 2 && 'bg-hoory-175 text-hoory-200'}`}>
            <span>All</span>
            <span className="text-xs ml-1  font-bold flex items-center justify-center rounded-full bg-white w-[15px] h-[15px]">5</span>
          </button>
        </div>
        <div className="w-full h-full max-h-[480px]  flex flex-col overflow-y-auto ">
          {new Array(15).fill("").map((item: any, index: number) =>
            <button key={index} className="w-full my-2 px-1 flex items-center ">
              <div className="w-[50px] h-[50px] bg-hoory-175 flex items-center justify-center text-hoory-200 rounded-full shadow">
                <CSvgAgents className="fill-hoory-200 w-[25px]" />
              </div>
              <div className="ml-2 flex flex-col items-start">
                <span className="text-sm">Ehsan Aghahoseini</span>
                <span className="text-gray-400 text-xs ">Hello ai chat ...</span>
              </div>
            </button>
          )}
        </div>
      </div>
    )
}